import { AddressQuickActions } from "./AddressQuickActions";
import { joinAddressLine } from "../components/raFormat";
import { AddressMeta } from "./AddressEdit";
import {
  AppShow,
  AppShowActions,
  AppShowCard,
  AppShowContent,
  AppShowSection,
  AppShowSectionHeader,
  AppShowField,
  AppShowTextField,
  AppShowFunctionField,
} from "@/adapters/inbound/layout";

export const AddressShow = () => (
  <AppShow actions={<AppShowActions />} aside={<AddressMeta />}>
    <AppShowCard>
      <AppShowContent>
        <AppShowSection>
          <AppShowSectionHeader
            title="Adresse"
            subtitle="Adressdaten und Bezeichnung."
          />
          <AppShowFunctionField
            label="Adresszeile"
            render={(r: any) => joinAddressLine(r)}
          />
          <AppShowTextField source="label" label="Bezeichnung" emptyText="—" />
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Standort"
            subtitle="Einzelne Bestandteile der Adresse."
          />
          <AppShowTextField source="street" label="Straße" emptyText="—" />
          <AppShowTextField source="streetNumber" label="Nr." emptyText="—" />
          <AppShowTextField source="zip" label="PLZ" emptyText="—" />
          <AppShowTextField source="city" label="Ort" emptyText="—" />
          <AppShowTextField source="country" label="Land" emptyText="—" />
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Aktionen"
            subtitle="Schnellzugriff für Navigation oder Kontakt."
          />
          <AppShowField label="Verfügbar">
            <AddressQuickActions />
          </AppShowField>
        </AppShowSection>

        <AppShowSection>
          <AppShowSectionHeader
            title="Geodaten"
            subtitle="Geocodierung der Adresse."
          />
          <AppShowFunctionField
            label="Koordinaten"
            render={(r: any) =>
              r?.lat != null && r?.lon != null
                ? `${r.lat}, ${r.lon}`
                : "— (noch nicht geocodiert)"
            }
          />
        </AppShowSection>
      </AppShowContent>
    </AppShowCard>
  </AppShow>
);
